import { render } from "./Marketing_Overview.vue?vue&type=template&id=4f7c10c6"
import script from "./Marketing_Overview.vue?vue&type=script&lang=js"
export * from "./Marketing_Overview.vue?vue&type=script&lang=js"

import "./Marketing_Overview.vue?vue&type=style&index=0&id=4f7c10c6&lang=scss"
script.render = render

export default script